



























































import BasicTs from '@/components/mixins/basicts.vue'
import moment from "moment-timezone";
import { Component, Vue, Mixins } from 'vue-property-decorator'
import * as types from '@/lib/definition/types'
moment.locale('ja')

@Component({
  mixins: [BasicTs]
})
export default class Clients extends Mixins(BasicTs) {
  private clients = new Array<types.ClientParam>()
  private addingObj: types.ClientParam = this.$store.direct.getters.Project.emptyClient
  private dialogAdding = false
  private objectToDelete: types.ClientParam = this.$store.direct.getters.Project.emptyClient
  private dialogDeleting = false
  private requestParam: any = null

  async mounted() {
  }
  async masterReady () {
    if (!this.$store.getters['Login/isAdmin']) {
      // redirect to home when you are not admin
      this.$router.push(this.site.deployFolder + "/")
    }
    await this.search()
  }
  async search () {
    this.clients = await this.$store.direct.dispatch.Project.listAllClients()
  }
  async prepareToAdd () {
    this.addingObj = await this.$store.direct.dispatch.Project.defaultClient()
    this.dialogAdding = true
  }
  prepareToDelete (item: types.ClientParam) {
    this.objectToDelete = item
    this.dialogDeleting = true
  }
  prepareToEdit (item: types.ClientParam) {
    this.addingObj = JSON.parse(JSON.stringify(item)) 
    this.dialogAdding = true
  }
  async confirmAdding () {
    this.dialogAdding = false
    this.requestParam = this.addingObj
    this.requestParam.isPersonal = false
    await this.$store.direct.dispatch.Project.addClient(this.requestParam); 
    this.dispSuccess('クライアントを追加しました。')
    this.search()
  }
  async confirmDeleting () {
    this.dialogAdding = false
    this.requestParam = this.addingObj
    this.requestParam.isPersonal = false
    // TODO add delete method
    await this.$store.direct.dispatch.Project.addClient(this.requestParam); 
    this.dispSuccess('クライアントを削除しました。')
    this.search()
  }
}
